import { defineStore } from "pinia";
import axios from "axios";
import { useAuthStore } from "@/auth/auth";
import { ApiSup } from "@/Functions/ApiSupport";

export const useEventStore = defineStore('eventStore',{
  state: () =>({
    eventx:[],
    schoolEvents: [],
    event: [],
    eventCount: []
  }),

  actions:{

   async  addEvent(body, perschoolid){
      const apiSup = ApiSup()
      const ret = await apiSup.postSupport('api/events/',body)
      if (perschoolid === ''){
        this.getEvent()
      }else{
        this.getEventPID(perschoolid)
      }
      return ret
    },


   async  updateEvent(pid ,body, perschoolid){
      const apiSup = ApiSup()
      const ret = await apiSup.putSupport('api/events/'+ pid,body)
      if (perschoolid === ''){
        this.getEvent()
      }else{
        this.getEventPID(perschoolid)
      }
      return ret
    },

   async  deleteEvent(pid , perschoolid){
      const apiSup = ApiSup()
      const ret = await apiSup.deleteSupport('api/events/'+ pid)
      if (perschoolid === ''){
        this.getEvent()
      }else{
        this.getEventPID(perschoolid)
      }
      return ret
    },

    async getEvent(school_id){

      const params = {
        school_id: school_id
      }
        const apiSup = ApiSup()
        const ret = await apiSup.getSupport('api/events/',{ params: params })

        this.eventx = ret
        this.schoolEvents = ret.data
        // return ret
    },
    async getEventPID(school_id){
      const params = {
        school_id: school_id
      }
      const authStore = useAuthStore()
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_HOST_API}/` + 'api/events/',
          {
            params: params,
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authStore.token}`,
            }
          }
        )

       this.eventx = response.data
       this.schoolEvents = response.data.data
      } catch (error) {
        console.error('Error fetching events:', error)
        throw error
      }
    },

    async getEventBySchool(pid){
        const apiSup = ApiSup()
        const ret = await apiSup.getSupport('api/schools/' + pid + '/events/')
        this.eventx = ret
        this.schoolEvents = ret.data.data
        // return ret
    }

  }

})
